import { TFunction } from "i18next";
import { ExamPeriodState } from "@types";
import { Typography } from "antd";

export const getTextByExamPeriodStatus = (status: ExamPeriodState | undefined, t: TFunction<"translation", undefined>) => {

    switch (status) {
        case ExamPeriodState.Active:
            return <Typography.Text strong type="success">{t("pages.examPeriods.active")}</Typography.Text>;
        case ExamPeriodState.InActive:
            return <Typography.Text strong type="secondary">{t("pages.examPeriods.inactive")}</Typography.Text>;
        case ExamPeriodState.Deleted:
            return <Typography.Text strong type="danger">{t("pages.examPeriods.deleted")}</Typography.Text>;
        case ExamPeriodState.Activated:
            return <Typography.Text strong type="success">{t("pages.examPeriods.activated")}</Typography.Text>;
        case ExamPeriodState.InProgress:
            return <Typography.Text strong type="success">{t("pages.examPeriods.inProgress")}</Typography.Text>;
        case ExamPeriodState.Completed:
            return <Typography.Text strong type="success">{t("pages.examPeriods.completed")}</Typography.Text>;
        case ExamPeriodState.BeingActivated:
            return <Typography.Text strong type="warning">{t("pages.examPeriods.beingActivated")}</Typography.Text>;
        case ExamPeriodState.BeingDeactivated:
            return <Typography.Text strong type="warning">{t("pages.examPeriods.beingDeactivated")}</Typography.Text>;
        default:
            return "";
    }
}